module.exports = __webpack_public_path__ + "static/media/hand_banner.39e80613.png";